import React, {useState} from "react";
import {Container, Row, Col, Button, Stack} from "../../components/ui";
import useApi from "../../hooks/useApi/useApi";
import {useQuery} from "react-query";
import {IUser} from "../../ModelContracts";
import UserCard from "../../components/UserCard/UserCard";
import CreateUser from "../../components/CreateUser/CreateUser";
import {Link} from "react-router-dom";

function Account() {
	const [users, setUsers] = useState([] as IUser[]);
	const [isCreating, setIsCreating] = useState(false);
	const {getUsers, getAvailableUsers} = useApi();

	useQuery('users', () => getUsers(), {
		onSuccess: (users: IUser[]) => {
			setUsers(users);
		}
	});

	const {data: availableUsers} =
		useQuery(['available-users'], () => getAvailableUsers());

	const handleStartCreating = () => setIsCreating(true);
	const handleStopCreating = () => setIsCreating(false);

	return (
		<Container fluid>
			<Row className="mt-6 mb-2 items-center justify-between">
				<Col xs={2}>
					<h2>Account</h2>
				</Col>
				<Col xs={9} className="flex justify-end">
					<Stack direction="horizontal" className="items-center">
						{
							!availableUsers?.moreAvailable &&
                            <p className="text-sm italic m-0 px-4">
                                <Link to={"/plan"}
                                      className="underline">Upgrade plan</Link> or delete user to add
                                more
                            </p>
						}
						<Button onClick={handleStartCreating}
						        disabled={!availableUsers?.moreAvailable}>Create User</Button>
					</Stack>
				</Col>
			</Row>
			<Row className="mt-6">
				{
					users.map((user: IUser) => (
						<Col key={user.id} xs={6} md={3} className="mb-4">
							<UserCard user={user}/>
						</Col>
					))
				}
			</Row>
			<CreateUser isVisible={isCreating} onClose={handleStopCreating}/>
		</Container>
	);
}

export default Account;
